export class MainMenu {

    constructor() {

        jQuery(document).ready(function($) {
            if ($('header').length > 0) {
                var offset=175;
                var stickyNav = function() {
                    var scrollTop = $(window).scrollTop();
                    if (scrollTop >= offset) {
                        $('header').addClass('condensed');
                    } else {
                        $('header').removeClass('condensed');
                    }
                };
                stickyNav();
                $(window).scroll(function() {
                    stickyNav();
                });
            }
        });


        this.initDropdowns();
    }

    initDropdowns() {
        let dropdowns = document.querySelectorAll('.js-dropdown');
        dropdowns.forEach(function(dropdown) {
            dropdown.querySelector('.js-dropdown-trigger').addEventListener('click', function() {
                dropdown.classList.toggle('is-open');
            });
        });

        document.addEventListener('click', function(event) {
            dropdowns.forEach(function(dropdown) {
                if (!dropdown.contains(event.target)) {
                    dropdown.classList.remove('is-open');
                }
            });
        })
    }



}